var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "200px",
    width: "200px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "332.108,12.159 332.108,41.513 332.108,70.868 332.108,138.376 399.617,138.376 428.972,138.376 458.329,138.376 "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M449.73,179.889h-20.757H311.351c-11.463,0-20.757-9.294-20.757-20.757V41.513V20.757V0H131.459 c-11.463,0-20.757,9.294-20.757,20.757v401.297c0,11.463,9.294,20.757,20.757,20.757h318.27c11.463,0,20.757-9.293,20.757-20.757 V179.889H449.73z M366.703,359.784H214.487c-11.463,0-20.757-9.294-20.757-20.757s9.294-20.757,20.757-20.757h152.216 c11.463,0,20.757,9.294,20.757,20.757S378.166,359.784,366.703,359.784z M366.703,276.757H214.487 c-11.463,0-20.757-9.294-20.757-20.757s9.294-20.757,20.757-20.757h152.216c11.463,0,20.757,9.294,20.757,20.757 S378.166,276.757,366.703,276.757z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M380.541,470.487H83.027V89.946c0-11.463-9.294-20.757-20.757-20.757s-20.757,9.293-20.757,20.757v401.297 c0,11.463,9.294,20.757,20.757,20.757h318.27c11.463,0,20.757-9.293,20.757-20.757 C401.297,479.78,392.004,470.487,380.541,470.487z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.5631390fd9b8bc6f79f09379014775ad.svg";
export { ForwardRef as ReactComponent };